import { createLoginPage } from './pages/Login';
import { handleAuthCallback } from './pages/AuthCallback';
import { twitchService } from './lib/twitch';
import { createMainApp } from './app';
import { trackPageView } from './utils/analytics';
import { GlobalChatManager } from './lib/chat/GlobalChatManager';

let isNavigating = false;
let lastAttemptedRoute: string | null = null;
let chatManager: GlobalChatManager | null = null;

export async function router() {
  const currentPath = window.location.pathname + window.location.search;
  
  // Track page view
  trackPageView(currentPath);
  
  // Prevent navigation loops
  if (isNavigating || currentPath === lastAttemptedRoute) {
    return;
  }

  isNavigating = true;
  lastAttemptedRoute = currentPath;
  
  const app = document.querySelector<HTMLDivElement>('#app')!;

  try {
    // Store chat manager reference before clearing
    if (!chatManager) {
      chatManager = GlobalChatManager.getInstance();
    }

    // Clear previous content
    const chatContainer = document.querySelector('#chatContainer');
    if (chatContainer) {
      // If we have a chat container, preserve it
      chatContainer.remove();
      app.innerHTML = '';
      // Re-add the chat container
      app.appendChild(chatContainer);
    } else {
      app.innerHTML = '';
    }

    // Handle auth callback
    if (currentPath.startsWith('/auth/callback') || window.location.search.includes('code=')) {
      await handleAuthCallback();
      return;
    }

    try {
      // Check authentication and handle token refresh
      const isAuthed = await twitchService.isAuthenticated();
      
      if (!isAuthed) {
        app.appendChild(createLoginPage());
        return;
      }

      // Verify user data
      const user = twitchService.getUser();
      if (!user) {
        app.appendChild(createLoginPage());
        return;
      }

      // Show main app for authenticated users
      app.appendChild(await createMainApp());
    } catch (error) {
      app.appendChild(createLoginPage());
    }
  } catch (error) {
    console.error('Router error:', error);
    app.appendChild(createLoginPage());
  } finally {
    isNavigating = false;
  }
}

// Initialize router
function initRouter() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', router);
  } else {
    router();
  }
}

// Start the router
initRouter();

// Handle browser navigation
window.addEventListener('popstate', router);

// Add periodic token refresh check (every minute)
setInterval(async () => {
  try {
    await twitchService.isAuthenticated();
  } catch (error) {
    console.error('Token refresh check failed:', error);
  }
}, 60000);
